import { simpleSet } from '@r/reducers/utils';

const setCalculationModeHingesValue = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.materials.hinges.value;

export const value = setCalculationModeHingesValue(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_HINGES_VALUE',
  { value: '', label: '' }
);
